import {
  arrayOf,
  bool,
  extend,
  number,
  params,
  shape,
  string,
  customType
} from '@thd-nucleus/data-sources';
import { Price } from '@thd-olt-component-react/price';

const RequestContext = {
  isBrandPricingPolicyCompliant: bool().isRequired()
};

export const requestContext = customType('RequestContext').shape(RequestContext);

const getPartsServices = {
  getPartsServices:
  params({
    itemIds: arrayOf(string().isRequired()).isRequired(),
    storeZip: string().isRequired(),
    requestContext
  }).shape({
    product: arrayOf(shape({
      addOns: arrayOf(shape({
        description: string(),
        installation: bool(),
        twoStepInstallation: bool(),
        price: number(),
        configAttr: string(),
        termLength: number(),
        category: string(),
        type: string()
      })),
      identifiers: shape({
        brandName: string(),
        productLabel: string()
      }),
      itemId: string(),
      media: shape({
        images: arrayOf(shape({
          url: string()
        })),
      }),
      pricing: shape({
        mapDetail: shape({
          mapPolicy: string()
        }),
        original: number({ float: true }),
        unitOfMeasurement: string(),
        value: number({ float: true })
      }),
    }))
  })
};

export const partsAndServicesDataModel = extend(getPartsServices, Price.dataModel);
